import { useEffect, useState } from 'react'

// True while the window is scrolled (near) to the very top. Pages that scroll an inner
// container instead (the schedule) never move the window, so they stay "at top".
export function useAtTop() {
  const [atTop, setAtTop] = useState(() => window.scrollY <= 4)
  useEffect(() => {
    const onScroll = () => setAtTop(window.scrollY <= 4)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return atTop
}
